import React from 'react';
import type { FC, ReactNode } from 'react';
import type { TextProps as InkTextProps } from 'ink';
import { Text as InkText } from 'ink';

const skins = {
  success: { backgroundColor: 'green' },
} as const satisfies Record<string, InkTextProps>;

export type BadgeSkin = keyof typeof skins;

export interface BadgeProps {
  skin: BadgeSkin;
  children: ReactNode;
}

export const Badge: FC<BadgeProps> = ({ children, skin }) => {
  return <InkText {...skins[skin]}> {children} </InkText>;
};
